/**
 * Oculta opciones de cantidad no disponibles para la variante seleccionada.
 * En vez de mostrarlas tachadas, las elimina visualmente.
 * Tema: Savor — Perú Vibes N' Bites
 */

function hideUnavailableQuantityOptions(picker) {
  const fieldsets = picker.querySelectorAll('fieldset');

  fieldsets.forEach((fieldset) => {
    const legend = fieldset.querySelector('legend')?.textContent?.trim().toLowerCase();
    if (!legend?.includes('cantidad')) return;

    fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
      const isUnavailable =
        input.dataset.optionAvailable === 'false' ||
        input.getAttribute('aria-disabled') === 'true';

      // Buscar el label asociado (el elemento visual visible)
      const label =
        fieldset.querySelector(`label[for="${input.id}"]`) ||
        input.closest('label');

      if (label) {
        label.style.display = isUnavailable ? 'none' : '';
      }
    });
  });
}

function observeVariantPickers() {
  document.querySelectorAll('variant-picker').forEach((picker) => {
    hideUnavailableQuantityOptions(picker);

    new MutationObserver(() => {
      hideUnavailableQuantityOptions(picker);
    }).observe(picker, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-option-available', 'aria-disabled', 'checked'],
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeVariantPickers);
} else {
  observeVariantPickers();
}
